
import { useAuth } from '@/context/AuthContext'
import { usePartner } from '@/context/PartnerContext'
import { getOfferTypeName, OfferType } from 'BrokerTsLib/src/dtos'


/**
 * Returns set of supported insurance params types
 * @returns 
 */
export const useGetOfferTypes = () => {
  const { currentPartner } = usePartner()
  const { user } = useAuth()

  const result = []

  if (user?.mazdaInsuranceAllowed ?? false)
    result.push({
      offerType: OfferType.ZnacnovePojisteniMazda,
      name: getOfferTypeName(OfferType.ZnacnovePojisteniMazda) ?? 'Pojištění Mazda'
    })

  if (user?.subaruInsuranceAllowed ?? false)
    result.push({
      offerType: OfferType.ZnacnovePojisteniSubaru,
      name: getOfferTypeName(OfferType.ZnacnovePojisteniSubaru) ?? 'Pojištění Subaru'
    })

  if (user?.kiaInsuranceAllowed ?? false)
    result.push({
      offerType: OfferType.ZnackovePojisteniKia,
      name: getOfferTypeName(OfferType.ZnackovePojisteniKia) ?? 'Pojištění KIA'
    })

  if (user?.mgInsuranceAllowed ?? false)
    result.push({
      offerType: OfferType.ZnackovePojisteniMg,
      name: getOfferTypeName(OfferType.ZnackovePojisteniMg) ?? 'Pojištění MG'
    })

  // lukas to nechtel, tak to davam aspon pro nas
  if (user?.adminCebiaRights ?? false)
    result.push({
      offerType: OfferType.KoopSalon,
      name: getOfferTypeName(OfferType.KoopSalon) ?? 'KoopSalon'
    })

  return result
}